import { MainTracker } from './MainTracker';
import { getItem, setItem } from '../utils/SessionStorageWrapper';

/** Tracks an event once per session; optional dedupeKey scopes storage separately from eventName. */
export const trackOncePerSession = (
    eventType: string = 'custom',
    eventName: string,
    eventProperties: any = {},
    sessionDurationHours: number = 3,
    dedupeKey?: string
) => {
    const storageKey = `tracked_event_${dedupeKey || eventName}`;
    const now = new Date().getTime();
    const sessionDurationMs = sessionDurationHours * 60 * 60 * 1000;

    const lastTracked = getItem(storageKey);

    if (!lastTracked) {
        setItem(storageKey, now.toString());
        MainTracker.track(eventType, eventName, eventProperties);
        return true;
    }

    const lastTrackedTime = parseInt(lastTracked);
    const timeSinceLastTracked = now - lastTrackedTime;

    if (timeSinceLastTracked >= sessionDurationMs) {
        setItem(storageKey, now.toString());
        MainTracker.track(eventType, eventName, eventProperties);
        return true;
    }

    return false;
}; 